import { z } from "zod";

import { productSchema } from "./productSchema";
import { promoCodeSchema } from "./promoCodeSchema";

const introOfferSchema = z.object({
  amount: z.number(),
  locale: z.string(),
});

const cartErrorSchema = z.object({
  status: z.string(),
  error: z.string(),
  code: z.number(),
});

const taxSchema = z.object({
  name: z.string(),
  juris_name: z.string(),
  amount: z.number(),
});

export type Tax = z.infer<typeof taxSchema>;

const paymentPlatforms = z.enum(["stripe", "paypal", "hallow", "hotmart"]);

export type PaymentMethod = z.infer<typeof paymentPlatforms>;

export const cartSchema = z.object({
  cost_per_month: z.number().nullable(),
  country: z.string(),
  currency: z.string(),
  discount: z.number(),
  errors: z.array(cartErrorSchema),
  intro_offer: introOfferSchema.nullable(),
  is_renewing: z.boolean(),
  is_tax_inclusive: z.boolean(),
  needs_postal_code: z.boolean(),
  payment_required: z.boolean(),
  pretax_total: z.number(),
  product: productSchema,
  promo_code: promoCodeSchema.nullable(),
  renewal_discount: z.number(),
  renewal_pretax_total: z.number(),
  renewal_tax: z.number(),
  renewal_taxes: taxSchema.array(),
  renewal_total: z.number(),
  subtotal: z.number(),
  supported_payment_methods: z.array(z.string()).optional(),
  supported_platforms: z.array(paymentPlatforms),
  tax: z.number(),
  taxes: taxSchema.array(),
  total: z.number(),
  trial_end_date: z.iso.datetime(),
});

export type Cart = z.infer<typeof cartSchema>;

type PaymentAddress = {
  city?: string;
  line1?: string;
  line2?: string;
  postal_code?: string;
  state?: string;
  country?: string;
  metadata?: any;
};

export type PaymentResult = {
  paymentMethod: string | null;
  paymentPlatform?: "stripe" | "paypal";
  name?: string;
  email?: string;
  address?: PaymentAddress;
};
